import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['addButton', 'removeButton', 'unNo'];

  connect() {
    this.checkDisplayButtonConditions();
  }

  add() {
    const unNo = this.unNoTarget.cloneNode(true);
    unNo.querySelector('input').value = null;
    this.unNoTargets.slice(-1)[0].after(unNo);
    this.checkDisplayButtonConditions();
  }

  remove(e) {
    e.target.closest("[data-un-nos-target='unNo']").remove();
    this.checkDisplayButtonConditions();
  }

  checkDisplayButtonConditions() {
    for (let i = 0; i < this.unNoTargets.length; i += 1) {
      if (i === this.unNoTargets.length - 1) {
        this.unNoTargets[i].querySelector("[data-un-nos-target='addButton']").classList.remove('hidden');
        this.unNoTargets[i].querySelector("[data-un-nos-target='removeButton']").classList.add('hidden');
      } else {
        this.unNoTargets[i].querySelector("[data-un-nos-target='addButton']").classList.add('hidden');
        this.unNoTargets[i].querySelector("[data-un-nos-target='removeButton']").classList.remove('hidden');
      }
    }
  }
}
